import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { FeaturesSection } from './components/FeaturesSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { PricingSection } from './components/PricingSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection data-id="element-3" />
        <FeaturesSection data-id="element-4" />
        <HowItWorksSection data-id="element-5" />
        <PricingSection data-id="element-6" />
        <CTASection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}